import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import * as roomActions from 'features/room-builder/duck';
import { PAST_EVENTS_LIMIT } from '/shared/constants';
import { CopyRooms } from 'features/staff-and-rooms';
import './CreateRoom.scss';

class CreateRoom extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copyRoomsOpen: false,
      hasMatchingEvents: !!props.pastEvents.length,
    };

    this.toggleCopyRooms = this.toggleCopyRooms.bind(this);
    this.copyRooms = this.copyRooms.bind(this);
  }

  componentDidMount() {
    const { testCenterCycle, loadedPastEvents, loadingPastEvents, errorPastEvents, tcEvent } =
      this.props;

    if (
      !isEmpty(testCenterCycle) &&
      !loadedPastEvents &&
      !loadingPastEvents &&
      isEmpty(errorPastEvents)
    ) {
      this.props.actions.getPastEvents(testCenterCycle.id, tcEvent.id, {
        skip: 0,
        limit: PAST_EVENTS_LIMIT,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { loadedPastEvents, loadingPastEvents, errorPastEvents, pastEvents } = this.props;

    if (
      loadedPastEvents &&
      !loadingPastEvents &&
      isEmpty(errorPastEvents) &&
      !this.state.hasMatchingEvents &&
      (prevState.hasMatchingEvents || !!pastEvents.length)
    ) {
      this.setState({
        hasMatchingEvents: !!pastEvents.length,
      });
    }
  }

  toggleCopyRooms() {
    this.setState((prevState) => ({
      copyRoomsOpen: !prevState.copyRoomsOpen,
    }));
  }

  async copyRooms(data) {
    const { tcEvent } = this.props;

    await this.props.actions.copyRooms(tcEvent.id, data).then(() => {
      if (!this.props.errorCopyRooms) {
        this.toggleCopyRooms();
        this.props.copyRoomsSuccess();
      }
    });
  }

  render() {
    const { copyRoomsOpen, hasMatchingEvents } = this.state;
    const { testCenterCycle, tcEvent, locations, loadedPastEvents } = this.props;

    return (
      loadedPastEvents && (
        <div className="create-room border-box-radius">
          <h5 className="fw-bold">{this.props.t('roomBuilder.noRooms')}</h5>
          <p className="mb-0">
            {hasMatchingEvents
              ? this.props.t('roomBuilder.copyRoomsMessage')
              : this.props.t('roomBuilder.noRoomsMessage')}
          </p>
          <div className="buttons-section w-100">
            <button
              className="btn btn-small btn-action"
              onClick={this.toggleCopyRooms}
              disabled={!hasMatchingEvents || this.props.tcEvent.studyFlag}>
              {this.props.t('roomBuilder.copyRoomsLabel')}
            </button>
            <button
              className={`btn btn-small ${!hasMatchingEvents ? 'btn-action' : ''}`}
              onClick={() => this.props.onCreateRoom()}>
              {this.props.t('roomBuilder.createNewRoomLabel')}
            </button>
          </div>

          <CopyRooms
            copyRoomsOpen={copyRoomsOpen}
            closeModal={this.toggleCopyRooms}
            copyRooms={this.copyRooms}
            locations={locations}
            currentEvent={tcEvent}
            tcCycleId={testCenterCycle.id}
          />
        </div>
      )
    );
  }
}
function mapStateToProps(state) {
  return {
    pastEvents: state.roomOptions.pastEvents,
    loadedPastEvents: state.roomOptions.loadedPastEvents,
    loadingPastEvents: state.roomOptions.loadingPastEvents,
    errorPastEvents: state.roomOptions.errorPastEvents,
    errorCopyRooms: state.roomOptions.errorCopyRooms,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...roomActions }, dispatch),
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CreateRoom));

CreateRoom.propTypes = {
  onCreateRoom: PropTypes.func.isRequired,
  tcEvent: PropTypes.shape({
    testingEvent: PropTypes.shape({
      testDate: PropTypes.string,
    }),
  }).isRequired,
  testCenterCycle: PropTypes.shape({}).isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  copyRoomsSuccess: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
